import moment from 'moment';

export const formatDate = (dateString) => {
    return moment(dateString).format('MMM D, YYYY');
};

export const FormatTime = (time) => {
    if (!time) return "";
    const [hour, minute] = time.split(":").map(Number);
    const ampm = hour >= 12 ? "PM" : "AM";
    const formattedHour = hour % 12 || 12; // Convert 0 to 12 for 12 AM/PM
    return `${formattedHour}:${minute.toString().padStart(2, "0")} ${ampm}`;
};
export const GetDayName = (dateInput) => {
    if (!dateInput) return null; 

    const date = new Date(dateInput);

    if (isNaN(date.getTime())) {
        console.error("Invalid date format:", dateInput);
        return null;
    }

    return date.toLocaleDateString('en-US', { weekday: 'long' });
};  